



















































































































import { Component, Prop, Vue } from "@/shared/vuepack";
import {
  hsabExpenseCategoryMap,
  HsabExpenseOriginator,
  hsabExpenseOriginatorTypeMap,
  HsabExpenseResponse,
  ManagedExpenseFilterType,
  ManagedExpenseResponse,
  ManagedExpensesSortableColumns,
  ManagedExpenseType,
  SortOrder,
  UnusedDistributionResponse
} from "@/shared/types";
import { formatCurrency } from "@/shared/currency";
import moment from "moment";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import Paginator from "@/shared/components/ui/Paginator.vue";
import AccountHolderWidgetBase from "@/employer/components/partner-ee-service/AccountHolderWidgetBase.vue";
import HsabExpenseReimbursementStatusPill
  from "@/employee/components/landing-pages/hsabank/expense/hsabExpenseCard/HsabExpenseReimbursementStatusPill.vue";
import AccountHolderExpenseModal from "@/employer/components/partner-ee-service/AccountHolderExpenseModal.vue";
import { useManagedExpenseStore } from "@/employee/store/managedExpense";
import { useHsabExpenseStore } from "@/employee/store/hsabExpense";
import { expenseCategoryIcon, expenseSourceIcon } from "@/shared/awesomeIconMapper";

@Component({
  components: {
    GenericLoadingSpinner,
    AccountHolderWidgetBase,
    HsabExpenseReimbursementStatusPill,
    AccountHolderExpenseModal,
    Paginator
  }
})
export default class AccountHolderExpenses extends Vue {
  formatCurrency = formatCurrency;
  managedExpensesStore = useManagedExpenseStore();
  hsabExpenseStore = useHsabExpenseStore();
  loaded = false;
  expenseCategoryIcon = expenseCategoryIcon;
  expenseSourceIcon = expenseSourceIcon;
  hsabExpenseOriginatorTypeMap = hsabExpenseOriginatorTypeMap;
  hsabExpenseCategoryMap = hsabExpenseCategoryMap;
  ManagedExpenseFilterType = ManagedExpenseFilterType;

  sortDescending = false;
  showExpenseModal = false;
  sortOption = ManagedExpensesSortableColumns.Date;
  expense: HsabExpenseResponse = null;
  unusedDistribution: UnusedDistributionResponse = null;

  @Prop({ default: () => ManagedExpenseFilterType.MyExpenses })
  filter: ManagedExpenseFilterType;

  @Prop({ required: true })
  username: string;

  @Prop({ required: true })
  partnerId: number;
  mounted () {
    this.loadData();
  }
  get isLoading () {
    return this.managedExpensesStore.isCurrentPageLoading;
  }

  get isLoaded () {
    return this.managedExpensesStore.isCurrentPageLoaded;
  }

  get isFailed () {
    return this.managedExpensesStore.isCurrentPageLoadFailed;
  }

  get hasData () {
    return this.items && this.items.length > 0;
  }
  loadData () {
    if (!this.loaded) {
      const args = { username: this.username, partnerId: this.partnerId };
      this.managedExpensesStore.loadManagedExpensesByPage(1, this.filter, args);
      this.loaded = true;
    }
  }
  get currentPage () {
    return this.managedExpensesStore.currentPageNumber;
  }

  get pageCount () {
    return this.managedExpensesStore.totalPageCount;
  }

  get hasPages () {
    return this.managedExpensesStore.totalPageCount > 0;
  }
  get items () {
   return this.managedExpensesStore.currentPageItems;
  }

  onSwitchPage (pageNumber: number) {
    const args = { username: this.username, partnerId: this.partnerId };
    this.managedExpensesStore.loadManagedExpensesByPage(pageNumber, this.filter, args);
  }
  getFormattedDate (date?: string): string {
    return date && moment(date).format("MMM D, YYYY") || "(unknown)";
  }
  getFormattedMonthAndDay (date?: string): string {
    return date && moment(date).format("MMM D") || "(unknown)";
  }
  formattedOriginator (originator: HsabExpenseOriginator) {
    if (originator) {
      return this.hsabExpenseOriginatorTypeMap[originator];
    }
    return "Unknown";
  }
  get showTalonClaims (): boolean {
    return false;
  }
  onFilterClicked (filter: ManagedExpenseFilterType) {
    if (filter !== this.filter) {
      this.managedExpensesStore.resetFilters();
      this.filter = filter;
      const args = { username: this.username, partnerId: this.partnerId };
      this.managedExpensesStore.loadManagedExpensesByPage(1, this.filter, args);
    }
  }
  onSortChanged (ctx) {
    this.sortDescending = ctx.sortDesc;
    const order = ctx.sortDesc ? SortOrder.Descending : SortOrder.Ascending;
    let sortBy = ManagedExpensesSortableColumns.Date;
    switch (ctx.sortBy) {
      case "amount":
        sortBy = ManagedExpensesSortableColumns.Amount;
        break;
      case "provider":
        sortBy = ManagedExpensesSortableColumns.Provider;
        break;
      case "dateOfService":
      case "dateRange":
        sortBy = ManagedExpensesSortableColumns.Date;
        break;
      case "lastModified":
        sortBy = ManagedExpensesSortableColumns.LastModified;
        break;
      case "status":
        sortBy = ManagedExpensesSortableColumns.Status;
        break;
      case "planName":
        sortBy = ManagedExpensesSortableColumns.PlanName;
        break;
      case "originator":
        sortBy = ManagedExpensesSortableColumns.Source;
        break;
      case "created":
        sortBy = ManagedExpensesSortableColumns.Created;
        break;
    }
    this.sortOption = ctx.sortBy;
    const args = { username: this.username, partnerId: this.partnerId };
    this.managedExpensesStore.setSortByColumnAndSortOrderAndFilter(sortBy, order, this.filter, args);
  }
  async onRowClicked (item: ManagedExpenseResponse, index: number) {
    const args = { username: this.username, partnerId: this.partnerId };
    if (item.managedExpenseType === ManagedExpenseType.Transaction) {
      this.unusedDistribution = await this.hsabExpenseStore.loadDebitCardReimbursementById(item.reimbursementId, args);
    } else if (item.managedExpenseType === ManagedExpenseType.RecurringTemplate) {
      this.expense = await this.hsabExpenseStore.loadExpenseWithRelationshipsById(item.expenseId, true, args);
    } else {
      this.expense = await this.hsabExpenseStore.loadExpenseById(item.expenseId, true, args);
    }
    this.showExpenseModal = true;
  }
  handleOnEditClose () {
    this.showExpenseModal = false;
  }
  get isRecurringMode (): boolean {
    return this.managedExpensesStore.currentBaseFilter === ManagedExpenseFilterType.RecurringExpenseTemplates;
  }
  get visibleFields () {
    return this.listFields.filter(field => {
      if (field.key === "schedule" && !this.isRecurringMode) return false;
      if (field.key === "dateRange" && !this.isRecurringMode) return false;
      if (field.key === "dateOfService" && this.isRecurringMode) return false;
      if (field.key === "originator" && this.isRecurringMode) return false;
      if (field.key === "planName" && this.isRecurringMode) return false;
      return true;
    });
  }
  listFields = [
  {
    key: "provider",
    label: "Expense Provider",
    thClass: "text-left",
    tdClass: "align-middle",
    sortable: true
  },
  {
    key: "expenseCategory",
    label: "Category",
    thClass: "text-left",
    tdClass: "align-middle",
    sortable: false
  },
  {
    key: "amount",
    label: "Amount",
    thClass: "text-left",
    tdClass: "align-middle",
    sortable: true
  },
  {
    key: "dateOfService",
    label: "Date of Service",
    thClass: "",
    tdClass: "align-middle",
    sortable: true
  },
  {
    key: "dateRange",
    label: "Date Range",
    thClass: "",
    tdClass: "align-middle",
    sortable: true
  },
  {
    key: "schedule",
    label: "Schedule",
    thClass: "",
    tdClass: "align-middle",
    sortable: false
  },
  {
    key: "created",
    label: "Date Created",
    thClass: "",
    tdClass: "align-middle",
    sortable: true
  },
  {
    key: "lastModified",
    label: "Last Modified",
    thClass: "",
    tdClass: "align-middle",
    sortable: true
  },
  {
    key: "originator",
    label: "Originator",
    thClass: "text-left",
    tdClass: "align-middle",
    sortable: true
  },
  {
    key: "planName",
    label: "Plan Name",
    thClass: "text-left",
    tdClass: "align-middle",
    sortable: true
  },
  {
    key: "showErrorIndicator",
    label: "",
    thClass: "text-right",
    tdClass: ["text-right"],
    sortable: false
  },
  {
    key: "status",
    label: "Status",
    thClass: "",
    tdClass: "align-middle",
    sortable: true
  }];
}
